import { render, staticRenderFns } from "./Impressions.vue?vue&type=template&id=1f320ade&scoped=true&"
import script from "./Impressions.vue?vue&type=script&lang=js&"
export * from "./Impressions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f320ade",
  null
  
)

export default component.exports